import { render, staticRenderFns } from "./room-roles.vue?vue&type=template&id=a6899034&scoped=true&"
import script from "./room-roles.vue?vue&type=script&lang=js&"
export * from "./room-roles.vue?vue&type=script&lang=js&"
import style0 from "./room-roles.vue?vue&type=style&index=0&id=a6899034&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6899034",
  null
  
)

export default component.exports